package com.solevo.dist.network.api.products

import com.solevo.dist.application.models.Product
import com.solevo.dist.application.models.ProductCategory
import com.solevo.dist.network.infrastructure.utils.DefaultRemoteSourceImplementationException
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow

interface ProductRemoteSource {
    fun getAllProductsLive(): Flow<List<Product>> = flow { throw DefaultRemoteSourceImplementationException() }
    fun getProducts(ids: List<String>): Flow<List<Product>> = flow { throw DefaultRemoteSourceImplementationException() }
    fun getProductDetailsLive(productId: String): Flow<Product> = flow { throw DefaultRemoteSourceImplementationException() }
    suspend fun getProductDetails(productId: String): Result<Product?> = Result.failure(DefaultRemoteSourceImplementationException())
    fun getAllProductCategoriesLive(): Flow<List<ProductCategory>> = flow { throw DefaultRemoteSourceImplementationException() }
    fun getProductCategoryLive(categoryId: String): Flow<ProductCategory> = flow { throw DefaultRemoteSourceImplementationException() }
}